import { render, staticRenderFns } from "./EditShortlink.vue?vue&type=template&id=a6be5780&scoped=true"
import script from "./EditShortlink.vue?vue&type=script&lang=js"
export * from "./EditShortlink.vue?vue&type=script&lang=js"
import style0 from "./EditShortlink.vue?vue&type=style&index=0&id=a6be5780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6be5780",
  null
  
)

export default component.exports